import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { IconTile } from '@atlaskit/icon';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, Stack, xcss, Text } from '@atlaskit/primitives';
import { fg } from '@confluence/feature-gating';

const i18n = defineMessages({
	deletedGroup: {
		id: 'share-and-restrict-dialog.makeBodyProps.avatarGroupData.deletedGroup',
		defaultMessage: 'This group was deleted',
		description: 'The name shown for the deleted group in the specific access component',
	},
	deletedGroupOrTeam: {
		id: 'share-and-restrict-dialog.makeBodyProps.avatarGroupData.deletedGroupOrTeam',
		defaultMessage: 'This group or team was deleted',
		description: 'The name shown for the deleted group or team in the specific access component',
	},
});

const principalDetailsStyle = xcss({
	overflowWrap: 'anywhere',
});

export const DeletedGroupDetails = ({}) => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.150" alignBlock="center">
			<IconTile label="" size="32" appearance="gray" shape="circle" icon={PeopleGroupIcon} />
			<Stack>
				<Stack xcss={principalDetailsStyle}>
					<Inline>
						<Text>
							{formatMessage(
								fg('confluence_frontend_perms_exp_teams_as_principals')
									? i18n.deletedGroupOrTeam
									: i18n.deletedGroup,
							)}
						</Text>
					</Inline>
				</Stack>
			</Stack>
		</Inline>
	);
};
